module.exports = __webpack_public_path__ + "img/praia.45cedaff.jpg";